/* eslint-disable */
import React, { useState, useEffect, useRef, useCallback } from 'react';
import { DragDropContext, Droppable, Draggable } from 'react-beautiful-dnd';
import LoaderGraphic from '../../utils/LoaderGraphic';
import CopilotSlideOut from '../CopilotSlideOut';
import ProgressBarModal from '../../progress_bar/ProgressBarModal';
import ExportDropdown from '../utils/ExportDropdown';
import EditDashboard from '../utils/EditDashboard';
import { mergeItems } from '../charts';
import PracticeReport from './PracticeReport';
import PRDropdownFilter from '../PRDropdownFilter';
import DashboardViewModal from '../utils/DashboardViewModal';
import ExportPracticeFirmPDF from '../ExportPracticeFirmPDF';
import { ToastContainer, toast } from 'react-toastify';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faQuestionCircle } from '@fortawesome/free-regular-svg-icons';
import { faAnglesLeft } from "@fortawesome/free-solid-svg-icons";
import { useTour } from '@reactour/tour';
import Modal from 'react-modal';
import DOMPurify from 'dompurify';
import TextEditor from '../TextEditor';
import TextEditorPDF from '../TextEditorPDF';

const sanitizeOptions = {
  ALLOWED_TAGS: [
    'table',
    'thead',
    'tbody',
    'tfoot',
    'tr',
    'td',
    'th',
    'colgroup',
    'col',
    'h1','h2','h3','h4','h5','h6',
    'br','p','ul','ol','li','hr','div',
    'strong','em','u','s','a','span','mark'
  ],
  ALLOWED_ATTR: [
    'href', 'target', 'rel', 'style', 'dir', 'class', 'colspan', 'rowspan', 'colwidth', 'data-colwidth'
  ]
};

const debounce = (fn, delay) => {
  let timeout;
  return (...args) => {
      clearTimeout(timeout);
      timeout = setTimeout(() => fn(...args), delay);
  };
};

const PracticeReportContainer = (props) => {
  const componentRefs = useRef();
  const navbar = window.navbar.navbar;
  const { isOpen, currentStep, steps, setIsOpen, setCurrentStep } = useTour();
  const [copilotOpen, setCopilotOpen] = useState(false)
  const [reportsOnTabs, setReportsOnTabs] = useState([
    { key: 'client-analysis', checked: true, name: 'Client Analysis', display_on_tab: true, active_view: true, tab_order: 1, multiple_reports: false, report: "client-analysis" },
    { key: 'pnl', checked: true, name: 'Profit & Loss', display_on_tab: true, active_view: false, tab_order: 2, multiple_reports: false, report: "pnl" },
    { key: 'balance-sheet', checked: true, name: 'Balance Sheet', display_on_tab: true, active_view: false, tab_order: 3, multiple_reports: false, report: "balance-sheet" },
    { key: 'dashboard', checked: true, name: 'Dashboard', display_on_tab: true, active_view: false, tab_order: 4, multiple_reports: false, report: "dashboard" },
  ])
  const [activeTab, setActiveTab] = useState('client-analysis');
  const [isLoading, setIsLoading] = useState(false);
  const [practiceCalcsProgressBar, setPracticeCalcsProgressBar] = useState(false);
  const [tableState, setTableState] = useState({
    submitted: {
      sort: 'company_name',
      isDesc: false,
      pageCounter: 1
    },
    unsubmitted: {
      sort: 'company_name',
      isDesc: false,
      pageCounter: 1
    },

  })
  const [data, setData] = useState({
    naics_averages: '',
    average_of_all_submitted_children: '',
    dashboard_calculations: '',
    submitted_children: '',
    report_metrics: '',
    child_count: '',
    unsubmitted_child_count: 0,
    drillup: '',
    drillup_link: '',
    drillup_text: '',
    filterOptions: '',
    firm_name: '',
    firm_logo: '',
    focusedClientData: [],
    user_focused_clients: [],
    insufficientData: null,
    page: '',
    pieTopLevelArr: '',
    rankingData: '',
    tree: '',
    naics_trends_data: [],
    unsubmitted_children: '',
    user: 0,
    year: '',
    yearRange: ''
  })
  const [selectedFilters, setSelectedFilters] = useState({
    naics_string: 'All',
    revenue_band: 'All',
    region: 'All',
    partner: 'All',
    office: 'All',
    status: 'All',
    year: new Date().getFullYear() - 1,
  })
  const [dashboard, setDashboard] = useState({ id: null, selectedItems: [], layout: [], noChangesMade: true });
  const [dashboardViewModalState, setDashboardViewModalState] = useState({
    isOpen: false,
    action: 'close',
    edit_view: {},
    current_view: {},
    user_views: [],
    firms_views: []
  });
  const [filtersModalIsOpen, setFiltersModalIsOpen] = useState(false)
  const [activePopover, setActivePopover] = useState(null);
  const [openNotesForm, setOpenNotesForm] = useState(false);
  const [notesInput, setNotesInput] = useState({ error: null, name: '', permissions: 'private' });
  const [noteTabs, setNoteTabs] = useState([])
  const [companyNotes, setCompanyNotes] = useState([])
  const [activeCompanyNote, setActiveCompanyNote] = useState({})
  const [PDFPrintModalOpen, setPDFPrintModalOpen] = useState(false);
  const [displayPages, setDisplayPages] = useState([
    { title: 'Client Analysis', checked: true },
    { title: 'Profit & Loss', checked: true },
    { title: 'Balance Sheet', checked: true },
    { title: 'Dashboard', checked: true },
  ])

  useEffect(() => {
    setIsLoading(true)
    let allUrl = `/api/v1/practice_reportable?page=${tableState.submitted.pageCounter}&rows=${'25'}&sort=${tableState.submitted.sort}&direction=${tableState.submitted.isDesc ? 'desc' : 'asc'}&naics_string=${selectedFilters.naics_string === 'All' ? '' : selectedFilters.naics_string}&revenue_band=${selectedFilters.revenue_band === 'All' ? '' : selectedFilters.revenue_band}&region=${selectedFilters.region === 'All' ? '' : selectedFilters.region}&partner=${selectedFilters.partner === 'All' ? '' : selectedFilters.partner}&office=${selectedFilters.office === 'All' ? '' : selectedFilters.office}&status=${selectedFilters.status === 'All' ? '' : selectedFilters.status}&year=${selectedFilters.year}&commit=filter`
    const makeApiCall = async () => {
      const response = await fetch(allUrl);
      const json = await response.json();
      setData(prevState => {
        return {
          ...prevState,
          naics_averages: json.naics_averages,
          average_of_all_submitted_children: json.average_of_all_submitted_children,
          dashboard_calculations: json.dashboard_calculations,
          submitted_children: json.submitted_children,
          report_metrics: json.report_metrics,
          child_count: json.child_count,
          unsubmitted_child_count: json.unsubmitted_child_count,
          drillup: json.drillup,
          drillup_link: json.drillup_link,
          drillup_text: json.drillup_text,
          filterOptions: json.filter_options_obj,
          firm_name: json.firm_name,
          firm_logo: json.firm_logo,
          focusedClientData: json.user_focused_clients_info,
          user_focused_clients: json.user_focused_clients,
          insufficientData: json.insufficient_data,
          page: json.page,
          rankingData: json.snapshot_info,
          tree: json.tree,
          unsubmitted_children: json.unsubmitted_children,
          year: json.year,
          yearRange: json.yearRange,
          selected_filters: json.selected_filters,
          user: json.user
        }
      })
      setActiveTab(prevState => {
        return json.all_tabs.find(tab => tab.active_view)?.key || prevState
      })
      setReportsOnTabs(json.all_tabs || [])
      setNoteTabs(json.note_tabs)
      setCompanyNotes(json.practice_notes)
      setSelectedFilters(prevState => {
        return {
          ...prevState,
          naics_string: json.selected_filters.naics_string ||= 'All',
          revenue_band: json.selected_filters.revenue_band ||= 'All',
          region: json.selected_filters.region ||= 'All',
          partner: json.selected_filters.partner ||= 'All',
          office: json.selected_filters.office ||= 'All',
          status: json.selected_filters.status ||= 'All',
          year: json.year
        }
      })

      const dashBoard = await fetch(`/get_dashboard_view/?report_type=practice`, {
        headers: {
          'X-CSRF-Token': window.token,
        }
      })
      const dashBoardRes = await dashBoard.json();
      let currentDash = dashBoardRes['current_view']
      let { layout, selectedItems } = mergeItems('practice', currentDash.selected_items, currentDash.dashboard_layout)
      setDashboard(() => {
        return {
          id: currentDash.id,
          selectedItems: selectedItems,
          layout: layout,
          noChangesMade: true
        }
      })
      setDashboardViewModalState((prevState) => {
        return {
          ...prevState,
          current_view: dashBoardRes.current_view,
          user_views: dashBoardRes.user_views,
          firms_views: dashBoardRes.firms_views
        }
      })
      setIsLoading(false)
      props.tracker_id && !props.tour_taken ? setIsOpen(true) : null
    };
    makeApiCall();
  }, [])

  const handleDashboardSelections = (item, parentItemInfo = null) => {
    let itemsCheckedTrue = [];
    let newLayout = [];
    setDashboard((prevState) => {
      let oldDashInfo = _.cloneDeep(prevState);
      if (parentItemInfo) {
        let parentItem = oldDashInfo.selectedItems.find((c) => c.key === parentItemInfo.key);
        if (parentItem.children) {
          let childItem = parentItem.children.find((child) => child.key === item.key);
          childItem.checked = !childItem.checked
          let numberOfChildrenChecked = parentItem.children.filter(child => child.checked)
          parentItem.checked = numberOfChildrenChecked.length > 0
        }
      } else {
        let selectedChart = oldDashInfo.selectedItems.find((c) => c.key === item.key);
        let checkStatus = !selectedChart.checked
        if (selectedChart.children) {
          selectedChart.children = selectedChart.children.map((c) => {
            c.checked = checkStatus
            return c;
          })
        }
        selectedChart.checked = checkStatus;
      }

      oldDashInfo.selectedItems.forEach((c) => {
        if (c.checked) {
          if (c.children) {
            let clonedItem = _.cloneDeep(c);
            clonedItem.children = clonedItem.children.filter(child => child.checked)
            itemsCheckedTrue.push(clonedItem)
          } else {
            itemsCheckedTrue.push(c)
          }
        }
      })

      let width = 0
      itemsCheckedTrue.forEach((itemChecked, i) => {
        // Checked list will always have children array
        let oldItem = oldDashInfo.layout.find(d => d['i'] === itemChecked.key);
        if (oldItem) {
          if (itemChecked.children && itemChecked.children.length > 1) {
            let parentLayout = []
            // we found a parent and it has more than one child checked
            // Does the old layout have each child?
            // If it has a checked child return it, else create a new layout for the child
            itemChecked.children.forEach(child => {
              let newChildItem = oldItem.layout.find(o => o['i'] === child.key)
              // Can't find the child make a new one
              if (!newChildItem) {
                if (child.key.includes('ranking_table')) {
                  parentLayout.push({
                    i: child.key,
                    isBounded: false,
                    isDraggable: true,
                    isResizable: true,
                    x: ((i * 3) % (6)),
                    y: Infinity,
                    w: 2,
                    h: 2,
                    minW: 2,
                    minH: 2,
                    maxW: 4,
                    maxH: 4,
                    resizeHandles: ['se']
                  })
                } else {
                  parentLayout.push({
                    i: child.key,
                    isBounded: false,
                    isDraggable: true,
                    isResizable: true,
                    x: ((i * 3) % (6)),
                    y: Infinity,
                    w: 3,
                    h: 2,
                    minW: 3,
                    minH: 2,
                    maxW: 6,
                    maxH: 12,
                    resizeHandles: ['se']
                  })
                }
              } else {
                return parentLayout.push(newChildItem)
              }
            })
            oldItem.layout = parentLayout;
            newLayout.push(oldItem)
          } else if (itemChecked.children && itemChecked.children.length === 1) {
            let childKey = itemChecked.children[0].key
            let oldChildItem = oldDashInfo.layout.find(d => d['i'] === childKey);
            if (oldChildItem) {
              newLayout.push(oldChildItem)
            } else {
              if (childKey.includes('pie')) {
                newLayout.push({
                  i: childKey,
                  isBounded: false,
                  isDraggable: true,
                  isResizable: true,
                  x: ((i * 2) % (6)),
                  y: ((i * 2) % (3)),
                  w: 2,
                  h: 2,
                  minW: 1,
                  minH: 1,
                  maxW: 6,
                  maxH: 12,
                  resizeHandles: ['se']
                })
              } else if (childKey.includes('ranking_table')) {
                newLayout.push({
                  i: childKey,
                  isBounded: false,
                  isDraggable: true,
                  isResizable: true,
                  x: ((i * 3) % (6)),
                  y: Infinity,
                  w: 2,
                  h: 2,
                  minW: 2,
                  minH: 2,
                  maxW: 4,
                  maxH: 4,
                  resizeHandles: ['se']
                })
              } else {
                newLayout.push({
                  i: childKey,
                  isBounded: false,
                  isDraggable: true,
                  isResizable: true,
                  x: ((i * 3) % (6)),
                  y: Infinity,
                  w: 3,
                  h: 2,
                  minW: 3,
                  minH: 2,
                  maxW: 6,
                  maxH: 12,
                  resizeHandles: ['se']
                })
              }
            }
          } else {
            newLayout.push(oldItem)
          }
        } else {
          // can't find item then make a new one
          if (itemChecked.children && itemChecked.children.length > 1) {
            let parentLayout = []
            let parentHeight = 0;
            let parentWidth = 0;
            let parentDraggable = true;
            itemChecked.children.forEach((child, j) => {
              if (child.key.includes('ranking_table')) {
                parentWidth += 2
                if (parentWidth % 6 === 0) { parentHeight += 2 }
                parentLayout.push({
                  i: child.key,
                  isBounded: false,
                  isDraggable: true,
                  isResizable: true,
                  x: ((j * 4) % (6)),
                  y: Infinity,
                  w: 2,
                  h: 2,
                  minW: 2,
                  minH: 2,
                  maxW: 4,
                  maxH: 4,
                  resizeHandles: ['se']
                })
              } else {
                parentWidth += 4
                if (parentWidth % 6 === 0) { parentHeight += 2 }
                parentDraggable = false
                parentLayout.push({
                  i: child.key,
                  isBounded: false,
                  isDraggable: false,
                  isResizable: true,
                  x: ((j * 4) % (6)),
                  y: Infinity,
                  w: 4,
                  h: 2,
                  minW: 3,
                  minH: 2,
                  maxW: 6,
                  maxH: 12,
                  resizeHandles: ['se']
                })
              }
            })
            newLayout.push({
              i: itemChecked.key,
              layout: parentLayout,
              isBounded: false,
              isDraggable: parentDraggable,
              isResizable: true,
              x: ((i * 3) % (6)),
              y: Infinity,
              w: parentWidth > 6 ? 6 : parentWidth,
              h: parentHeight,
              minW: 2,
              minH: 2,
              maxW: 6,
              maxH: 18,
              resizeHandles: ['se']
            })
          } else {
            let key = itemChecked.children && itemChecked.children.length === 1 ? itemChecked.children[0].key : itemChecked.key
            if (key.includes('ranking_table')) {
              let finalWidth = 0
              if (0 < width && width < 6) {
                finalWidth = width
                width += 2
              } else {
                width = 2
                finalWidth = 0
              }
              newLayout.push({
                i: key,
                isBounded: false,
                isDraggable: true,
                isResizable: true,
                x: finalWidth,
                y: Infinity,
                w: 2,
                h: 2,
                minW: 2,
                minH: 2,
                maxW: 4,
                maxH: 4,
                resizeHandles: ['se']
              })
            } else if (key.includes('bar_chart')) {
              let finalWidth = 0
              if (0 < width && width < 6) {
                finalWidth = width
                width += 4
              } else {
                width = 4
                finalWidth = 0
              }
              newLayout.push({
                i: key,
                isBounded: false,
                isDraggable: false,
                isResizable: true,
                x: finalWidth,
                y: Infinity,
                w: 4,
                h: 2,
                minW: 2,
                minH: 2,
                maxW: 6,
                maxH: 12,
                resizeHandles: ['se']
              })
            } else if (key === 'practice_focused_clients') {
              newLayout.push({
                i: key,
                isBounded: false,
                isDraggable: true,
                isResizable: true,
                x: 0,
                y: Infinity,
                w: 3,
                h: 2,
                minW: 2,
                minH: 2,
                maxW: 6,
                maxH: 12,
                resizeHandles: ['se']
              })
            } else {
              let finalWidth = 0
              if (0 < width && width < 6) {
                finalWidth = width
                width += 6
              } else {
                width = 6
                finalWidth = 0
              }
              newLayout.push({
                i: key,
                isBounded: false,
                isDraggable: true,
                isResizable: true,
                x: finalWidth,
                y: Infinity,
                w: 6,
                h: 3,
                minW: 3,
                minH: 2,
                maxW: 6,
                maxH: 12,
                resizeHandles: ['se']
              })
            }
          }
        }
      })

      return { ...prevState, selectedItems: oldDashInfo.selectedItems, layout: newLayout, noChangesMade: false }
    })
  }

  const handleSelectAll = (select) => {
    setDashboard((prevState) => {
      let newLayout = []
      let oldDashInfo = _.cloneDeep(prevState);
      let allItems = oldDashInfo.selectedItems.map((item) => {
        if (item.children) {
          item.children = item.children.map((c) => {
            c.checked = select
            return c;
          })
        }
        item.checked = select;
        return item;
      })
      let width = 0
      allItems.forEach((itemChecked, i) => {
        // Checked list will always have children array
        if (itemChecked.checked) {
          let oldItem = oldDashInfo.layout.find(d => d['i'] === itemChecked.key);
          if (oldItem) {
            if (itemChecked.children && itemChecked.children.length > 1) {
              let parentLayout = []
              // we found a parent and it has more than one child checked
              // Does the old layout have each child?
              // If it has a checked child return it, else create a new layout for the child
              itemChecked.children.forEach(child => {
                let newChildItem = oldItem.layout.find(o => o['i'] === child.key)
                // Can't find the child make a new one
                if (!newChildItem) {
                  if (child.key.includes('ranking_table')) {
                    parentLayout.push({
                      i: child.key,
                      isBounded: false,
                      isDraggable: true,
                      isResizable: true,
                      x: ((i * 3) % (6)),
                      y: Infinity,
                      w: 2,
                      h: 2,
                      minW: 2,
                      minH: 2,
                      maxW: 4,
                      maxH: 4,
                      resizeHandles: ['se']
                    })
                  } else {
                    parentLayout.push({
                      i: child.key,
                      isBounded: false,
                      isDraggable: true,
                      isResizable: true,
                      x: ((i * 3) % (6)),
                      y: Infinity,
                      w: 3,
                      h: 2,
                      minW: 3,
                      minH: 2,
                      maxW: 6,
                      maxH: 12,
                      resizeHandles: ['se']
                    })
                  }
                } else {
                  return parentLayout.push(newChildItem)
                }
              })
              oldItem.layout = parentLayout;
              newLayout.push(oldItem)
            } else if (itemChecked.children && itemChecked.children.length === 1) {
              let childKey = itemChecked.children[0].key
              let oldChildItem = oldDashInfo.layout.find(d => d['i'] === childKey);
              if (oldChildItem) {
                newLayout.push(oldChildItem)
              } else {
                if (childKey.includes('pie')) {
                  newLayout.push({
                    i: childKey,
                    isBounded: false,
                    isDraggable: true,
                    isResizable: true,
                    x: ((i * 2) % (6)),
                    y: ((i * 2) % (3)),
                    w: 2,
                    h: 2,
                    minW: 1,
                    minH: 1,
                    maxW: 6,
                    maxH: 12,
                    resizeHandles: ['se']
                  })
                } else if (childKey.includes('ranking_table')) {
                  newLayout.push({
                    i: childKey,
                    isBounded: false,
                    isDraggable: true,
                    isResizable: true,
                    x: ((i * 3) % (6)),
                    y: Infinity,
                    w: 2,
                    h: 2,
                    minW: 2,
                    minH: 2,
                    maxW: 4,
                    maxH: 4,
                    resizeHandles: ['se']
                  })
                } else {
                  newLayout.push({
                    i: childKey,
                    isBounded: false,
                    isDraggable: true,
                    isResizable: true,
                    x: ((i * 3) % (6)),
                    y: Infinity,
                    w: 3,
                    h: 2,
                    minW: 3,
                    minH: 2,
                    maxW: 6,
                    maxH: 12,
                    resizeHandles: ['se']
                  })
                }
              }
            } else {
              newLayout.push(oldItem)
            }
          } else {
            // can't find item then make a new one
            if (itemChecked.children && itemChecked.children.length > 1) {
              let parentLayout = []
              let parentHeight = 0;
              let parentWidth = 0;
              let parentDraggable = true;
              itemChecked.children.forEach((child, j) => {
                if (child.key.includes('ranking_table')) {
                  parentWidth += 2
                  if (parentWidth % 6 === 0) { parentHeight += 2 }
                  parentLayout.push({
                    i: child.key,
                    isBounded: false,
                    isDraggable: true,
                    isResizable: true,
                    x: ((j * 4) % (6)),
                    y: Infinity,
                    w: 2,
                    h: 2,
                    minW: 2,
                    minH: 2,
                    maxW: 4,
                    maxH: 4,
                    resizeHandles: ['se']
                  })
                } else {
                  parentWidth += 4
                  if (parentWidth % 6 === 0) { parentHeight += 2 }
                  parentDraggable = false
                  parentLayout.push({
                    i: child.key,
                    isBounded: false,
                    isDraggable: false,
                    isResizable: true,
                    x: ((j * 4) % (6)),
                    y: Infinity,
                    w: 4,
                    h: 2,
                    minW: 3,
                    minH: 2,
                    maxW: 6,
                    maxH: 12,
                    resizeHandles: ['se']
                  })
                }
              })
              newLayout.push({
                i: itemChecked.key,
                layout: parentLayout,
                isBounded: false,
                isDraggable: parentDraggable,
                isResizable: true,
                x: ((i * 3) % (6)),
                y: Infinity,
                w: parentWidth > 6 ? 6 : parentWidth,
                h: parentHeight,
                minW: 2,
                minH: 2,
                maxW: 6,
                maxH: 18,
                resizeHandles: ['se']
              })
            } else {
              let key = itemChecked.children && itemChecked.children.length === 1 ? itemChecked.children[0].key : itemChecked.key
              if (key.includes('ranking_table')) {
                let finalWidth = 0
                if (0 < width && width < 6) {
                  finalWidth = width
                  width += 2
                } else {
                  width = 2
                  finalWidth = 0
                }
                newLayout.push({
                  i: key,
                  isBounded: false,
                  isDraggable: true,
                  isResizable: true,
                  x: finalWidth,
                  y: Infinity,
                  w: 2,
                  h: 2,
                  minW: 2,
                  minH: 2,
                  maxW: 4,
                  maxH: 4,
                  resizeHandles: ['se']
                })
              } else if (key.includes('bar_chart')) {
                let finalWidth = 0
                if (0 < width && width < 6) {
                  finalWidth = width
                  width += 4
                } else {
                  width = 4
                  finalWidth = 0
                }
                newLayout.push({
                  i: key,
                  isBounded: false,
                  isDraggable: false,
                  isResizable: true,
                  x: finalWidth,
                  y: Infinity,
                  w: 4,
                  h: 2,
                  minW: 2,
                  minH: 2,
                  maxW: 6,
                  maxH: 12,
                  resizeHandles: ['se']
                })
              } else if (key === 'practice_focused_clients') {
                newLayout.push({
                  i: key,
                  isBounded: false,
                  isDraggable: true,
                  isResizable: true,
                  x: 0,
                  y: Infinity,
                  w: 3,
                  h: 2,
                  minW: 2,
                  minH: 2,
                  maxW: 6,
                  maxH: 12,
                  resizeHandles: ['se']
                })
              } else {
                let finalWidth = 0
                if (0 < width && width < 6) {
                  finalWidth = width
                  width += 6
                } else {
                  width = 6
                  finalWidth = 0
                }
                newLayout.push({
                  i: key,
                  isBounded: false,
                  isDraggable: true,
                  isResizable: true,
                  x: finalWidth,
                  y: Infinity,
                  w: 6,
                  h: 3,
                  minW: 3,
                  minH: 2,
                  maxW: 6,
                  maxH: 12,
                  resizeHandles: ['se']
                })
              }
            }
          }
        }
      })

      return { ...prevState, selectedItems: allItems, layout: newLayout, noChangesMade: false }
    })
  }

  const createDashBoardView = async (newDashView) => {
    let newView = {
      name: newDashView.name,
      private: newDashView.viewVisibilty === 'only_me',
      report_type: 'practice',
      permission_details: newDashView.viewPermission,
      view_apply: newDashView.viewApply,
      selected_items: dashboard.selectedItems,
      dashboard_layout: dashboard.layout
    }

    try {
      const res = await fetch(`/dashboard_views`, {
        method: 'POST',
        headers: {
          'X-CSRF-Token': window.token,
          'Content-Type': 'application/json',
        },
        body: JSON.stringify(newView),
      })

      const dashViewRes = await res.json()
      if (!res.ok) {
        throw new Error('Network response was not ok.');
      } else {
        setDashboard((prevState) => {
          return {
            ...prevState,
            id: dashViewRes.current_view.id,
            noChangesMade: true
          }
        })
        setDashboardViewModalState(prevState => {
          return {
            ...prevState,
            current_view: dashViewRes.current_view,
            user_views: dashViewRes.user_views,
            firms_views: dashViewRes.firms_views
          }
        })
        toast.success('New view created!', {
          position: 'top-right',
          autoClose: 2000,
          hideProgressBar: true,
          closeOnClick: true,
          pauseOnHover: true,
          draggable: false,
          progress: undefined,
        });
      }
    } catch (error) {
      console.log(error);
      let errorMessage = dashViewRes.name ? `Name ${dashViewRes.name}` : 'New view was not created properly'
      toast.error(`Sorry something went wrong. ${errorMessage}.`, {
        position: 'top-right',
        autoClose: 5000,
        hideProgressBar: true,
        closeOnClick: true,
        pauseOnHover: true,
        draggable: false,
        progress: undefined,
      });
    }
  }

  const getDashBoardView = async (dashViewId) => {
    try {
      const res = await fetch(`/dashboard_views/${dashViewId}`, {
        method: 'GET',
        headers: {
          'X-CSRF-Token': window.token,
          'Content-Type': 'application/json',
        }
      })

      const dashViewRes = await res.json()
      if (!res.ok) {
        throw new Error('Network response was not ok.');
      } else {
        let currentDash = dashViewRes['current_view']
        setDashboard((prevState) => {
          return {
            ...prevState,
            id: currentDash.id,
            selectedItems: currentDash.selected_items,
            layout: currentDash.dashboard_layout,
            noChangesMade: true
          }
        })
        setDashboardViewModalState(prevState => {
          return {
            ...prevState,
            current_view: currentDash
          }
        })
      }
    } catch (error) {
      console.log(error);
      toast.error(`Sorry something went wrong.`, {
        position: 'top-right',
        autoClose: 5000,
        hideProgressBar: true,
        closeOnClick: true,
        pauseOnHover: true,
        draggable: false,
        progress: undefined,
      });
    }
  }

  const updateDashBoardView = async (e = false, dashId = null, dashViewInfo = null) => {
    if (e) { e.preventDefault() }
    let dashViewId = dashId
    const updatedView = {
      report_type: 'practice',
      selected_items: dashboard.selectedItems,
      dashboard_layout: dashboard.layout
    }
    if (!dashViewId) dashViewId = dashboard.id
    if (dashViewInfo) {
      updatedView['name'] = dashViewInfo.name
      updatedView['private'] = dashViewInfo.viewVisibilty === 'only_me'
      updatedView['permission_details'] = dashViewInfo.viewPermission
    }

    try {
      const res = await fetch(`/dashboard_views/${dashViewId}`, {
        method: 'PATCH',
        headers: {
          'X-CSRF-Token': window.token,
          'Content-Type': 'application/json',
        },
        body: JSON.stringify(updatedView),
      })

      const dashViewRes = await res.json()

      if (!res.ok) {
        throw new Error('Network response was not ok.');
      } else {
        setDashboard((prevState) => {
          return {
            ...prevState,
            noChangesMade: true
          }
        })
        setDashboardViewModalState((prevState) => {
          return {
            ...prevState,
            current_view: dashViewRes.current_view,
            user_views: dashViewRes.user_views,
            firms_views: dashViewRes.firms_views
          }
        })
        toast.success('Changes saved!', {
          position: 'top-right',
          autoClose: 2000,
          hideProgressBar: true,
          closeOnClick: true,
          pauseOnHover: true,
          draggable: false,
          progress: undefined,
        });
      }
    } catch (error) {
      console.log(error);
      toast.error('Sorry something went wrong. Changes to view could not be saved.', {
        position: 'top-right',
        autoClose: 3000,
        hideProgressBar: true,
        closeOnClick: true,
        pauseOnHover: true,
        draggable: false,
        progress: undefined,
      });
    }
  }

  const deleteDashBoardView = async (e, dashViewId) => {
    e.preventDefault()
    try {
      const res = await fetch(`/dashboard_views/${dashViewId}`, {
        method: 'DELETE',
        headers: {
          'X-CSRF-Token': window.token,
          'Content-Type': 'application/json',
        }
      })

      if (!res.ok) {
        throw new Error('Network response was not ok.');
      } else {
        let defaultView = dashboardViewModalState.firms_views.find(v => v.name === 'Default')
        let currentViewDeleted = dashViewId === dashboardViewModalState.current_view.id
        setDashboardViewModalState(prevState => {
          let oldUserViews = prevState.user_views
          let newUserViews = oldUserViews.filter(v => v.id !== dashViewId)
          let oldFirmsViews = prevState.firms_views
          let newFirmsViews = oldFirmsViews.filter(v => v.id !== dashViewId)

          if (currentViewDeleted) {
            return {
              ...prevState,
              current_view: defaultView,
              user_views: newUserViews,
              firms_views: newFirmsViews
            }
          } else {
            return {
              ...prevState,
              user_views: newUserViews,
              firms_views: newFirmsViews
            }
          }
        })

        setDashboard((prevState) => {
          if (currentViewDeleted) {
            return {
              id: defaultView.id,
              selectedItems: defaultView.selected_items,
              layout: defaultView.dashboard_layout,
              noChangesMade: true
            }
          } else {
            return prevState
          }
        })

        toast.success('View was deleted!', {
          position: 'top-right',
          autoClose: 2000,
          hideProgressBar: true,
          closeOnClick: true,
          pauseOnHover: true,
          draggable: false,
          progress: undefined,
        });
      }
    } catch (error) {
      console.log(error);
      toast.error('Sorry something went wrong. Try again later.', {
        position: 'top-right',
        autoClose: 2000,
        hideProgressBar: true,
        closeOnClick: true,
        pauseOnHover: true,
        draggable: false,
        progress: undefined,
      });
    }
  }

  const handleDashboardViewModal = (action, info = null) => {
    setDashboardViewModalState(prevState => {
      if (action === 'close') {
        return { ...prevState, isOpen: false, action: 'close' }
      } else if (action === 'edit_view') {
        let currentView = prevState.current_view
        let noViewEdit = currentView.permission_details !== 'view_only' || prevState.user_views.find(v => v.id === currentView.id)
        let currentInfo = !info ? currentView : info
        if (!noViewEdit) {
          toast.error(`Sorry You Are NOT Allowed to Edit this Dashboard View. You need to be the owner of this dashboard view in order to edit.`, {
            position: 'top-right',
            autoClose: 10000,
            hideProgressBar: true,
            closeOnClick: true,
            pauseOnHover: true,
            draggable: false,
            progress: undefined,
          });
          return prevState
        } else {
          return { ...prevState, isOpen: true, action: action, edit_view: currentInfo }
        }
      } else {
        return { ...prevState, isOpen: true, action: action, edit_view: {} }
      }
    })
  }

  const handleFocusedClients = async (clientType, clientInfo) => {
    let clientFocused = !clientInfo.focused_client
    let allFocusedClients = data.user_focused_clients;
    // info will be changed with filters
    if (clientFocused) {
      let clientExists = allFocusedClients.find(c => c === clientInfo.company_id)
      if (!clientExists) { allFocusedClients.push(clientInfo.company_id) }
    } else {
      allFocusedClients = allFocusedClients.filter(c => c !== clientInfo.company_id)
    }
    const updatedFocus = { focused_clients: allFocusedClients }

    try {
      const res = await fetch(`/api/v1/users/${data.user}`, {
        method: 'PATCH',
        headers: {
          'X-CSRF-Token': window.token,
          'Content-Type': 'application/json',
        },
        body: JSON.stringify(updatedFocus),
      })

      if (!res.ok) {
        throw new Error('Network response was not ok.');
      } else {
        const json = await res.json();
        setData((prevState) => {
          const focusedClients = clientType === 'clients-submitted' ? _.cloneDeep(prevState.submitted_children) : _.cloneDeep(prevState.unsubmitted_children)
          focusedClients.find(c => c.company_id === clientInfo.company_id).focused_client = !clientInfo.focused_client
          if (clientType === 'clients-submitted') {
            return ({
              ...prevState,
              focusedClientData: json.focused_clients,
              user_focused_clients: allFocusedClients,
              submitted_children: focusedClients
            })
          }

          if (clientType === 'clients-unsubmitted') {
            return ({
              ...prevState,
              focusedClientData: json.focused_clients,
              user_focused_clients: allFocusedClients,
              unsubmitted_children: focusedClients
            })
          }
        })

      }
    } catch (error) {
      console.log(error);
      toast.error('Sorry something went wrong. Changes were not saved properly.', {
        position: 'top-right',
        autoClose: 5000,
        hideProgressBar: true,
        closeOnClick: true,
        pauseOnHover: true,
        draggable: false,
        progress: undefined,
      });
    }
  }

  const handleOnLayoutChange = (dashBoardType, newLayout, parentLayout = null) => {
    let currentView = dashboardViewModalState.current_view
    let noChangesVal = currentView.permission_details === 'view_only' && !dashboardViewModalState.user_views.find(v => v.id === currentView.id)

    if (dashBoardType === 'parentMyDashBoard') {
      setDashboard((prevState) => {
        let oldLayout = prevState.layout;
        let modifiedLayout = oldLayout.map((ol) => {
          let findNewItem = newLayout.find(item => item.i === ol.i)
          if (findNewItem) {
            return { ...ol, ...findNewItem }
          } else {
            return ol;
          }
        })
        return { ...prevState, layout: modifiedLayout, noChangesMade: noChangesVal }
      })
    }

    if (dashBoardType === 'childMyDashBoard') {
      setDashboard((prevState) => {
        let modifiedLayout = _.cloneDeep(prevState.layout);
        let findParentLayout = modifiedLayout.find(ol => ol.i === parentLayout.i)
        let findParentLayoutIndex = modifiedLayout.findIndex(ol => ol.i === parentLayout.i)
        if (findParentLayout) {
          findParentLayout.layout = findParentLayout.layout.map(pl => {
            let findNewItem = newLayout.find(item => item.i === pl.i)
            if (findNewItem) {
              return { ...pl, ...findNewItem }
            } else {
              return pl;
            }
          })

          modifiedLayout[findParentLayoutIndex] = findParentLayout
        }
        return { ...prevState, layout: modifiedLayout, noChangesMade: noChangesVal }
      })
    }

  }

  const handleToggleDraggable = (key, dashType = '', parent = null, customKey = '') => {
    let currentView = dashboardViewModalState.current_view
    let noChangesVal = currentView.permission_details === 'view_only' && !dashboardViewModalState.user_views.find(v => v.id === currentView.id)
    setDashboard((prevState) => {
      let newLayout = _.cloneDeep(prevState.layout);
      let item = newLayout.findIndex((l) => l.i === key);
      if (item > -1) {
        newLayout[item].isDraggable = !newLayout[item].isDraggable
      } else {
        let parentItem = newLayout.find((l) => l.i === parent?.i);
        if (parentItem) {
          let childItem = parentItem.layout.find(c => c.i === key)
          if (childItem) { childItem.isDraggable = !childItem.isDraggable }
          parentItem.isDraggable = childItem.isDraggable
        }
      }
      return { ...prevState, layout: newLayout, noChangesMade: noChangesVal }
    })
  }

  const handleSubmit = async (e = false, isNaicsOnly = false, naicsString = '') => {
    e ? e.preventDefault() : null
    let res;
    setIsLoading(true)
    try {
      if (isNaicsOnly) {
        res = await fetch(`/api/v1/practice_reportable?page=${tableState.submitted.pageCounter}&rows=${'25'}&sort=${tableState.submitted.sort}&direction=${tableState.submitted.isDesc ? 'desc' : 'asc'}&naics_string=${naicsString}&revenue_band=${selectedFilters.revenue_band}&region=${selectedFilters.region}&partner=${selectedFilters.partner}&office=${selectedFilters.office}&status=${selectedFilters.status === 'All' ? '' : selectedFilters.status}&year=${selectedFilters.year}&commit=filter`, {
          headers: {
            'X-CSRF-Token': window.token,
          }
        })
        const json = await res.json();
        if (!json.insufficient_data) {
          setData(prevState => {
            return {
              ...prevState,
              naics_averages: json.naics_averages,
              average_of_all_submitted_children: json.average_of_all_submitted_children,
              dashboard_calculations: json.dashboard_calculations,
              submitted_children: json.submitted_children,
              report_metrics: json.report_metrics,
              child_count: json.child_count,
              unsubmitted_child_count: json.unsubmitted_child_count,
              drillup: json.drillup,
              drillup_link: json.drillup_link,
              drillup_text: json.drillup_text,
              filterOptions: json.filter_options_obj,
              insufficientData: json.insufficient_data,
              page: json.page,
              rankingData: json.snapshot_info,
              tree: json.tree,
              unsubmitted_children: json.unsubmitted_children,
              year: json.year,
              yearRange: json.yearRange,
              selected_filters: json.selected_filters
            }
          })
        } else {
          setData(prevState => {
            return {
              ...prevState,
              insufficientData: json.insufficient_data
            }
          })
        }
        setIsLoading(false)
      } else {
        res = await fetch(`/api/v1/practice_reportable?page=${tableState.submitted.pageCounter}&rows=${'25'}&sort=${tableState.submitted.sort}&direction=${tableState.submitted.isDesc ? 'desc' : 'asc'}&naics_string=${selectedFilters.naics_string}&revenue_band=${selectedFilters.revenue_band}&region=${selectedFilters.region}&partner=${selectedFilters.partner}&office=${selectedFilters.office}&status=${selectedFilters.status === 'All' ? '' : selectedFilters.status}&year=${selectedFilters.year}&commit=filter`, {
          headers: {
            'X-CSRF-Token': window.token,
          }
        })
        const json = await res.json();

        if (!json.insufficient_data) {
          setData(prevState => {
            return {
              ...prevState,
              naics_averages: json.naics_averages,
              average_of_all_submitted_children: json.average_of_all_submitted_children,
              dashboard_calculations: json.dashboard_calculations,
              submitted_children: json.submitted_children,
              report_metrics: json.report_metrics,
              child_count: json.child_count,
              unsubmitted_child_count: json.unsubmitted_child_count,
              drillup: json.drillup,
              drillup_link: json.drillup_link,
              drillup_text: json.drillup_text,
              filterOptions: json.filter_options_obj,
              focusedClientData: json.user_focused_clients_info,
              user_focused_clients: json.user_focused_clients,
              insufficientData: json.insufficient_data,
              page: json.page,
              rankingData: json.snapshot_info,
              tree: json.tree,
              unsubmitted_children: json.unsubmitted_children,
              year: json.year,
              yearRange: json.yearRange,
              selected_filters: json.selected_filters
            }
          })
        } else {
          setData(prevState => {
            return {
              ...prevState,
              insufficientData: json.insufficient_data
            }
          })
        }
        setIsLoading(false)
      }
    } catch (error) {
      console.log(error)
      toast.error('Sorry something went wrong. Please try again later.', {
        position: 'top-right',
        autoClose: 5000,
        hideProgressBar: true,
        closeOnClick: true,
        pauseOnHover: true,
        draggable: false,
        progress: undefined,
      });
      setIsLoading(false)
    }
  };

  const handleTableChanges = async (action, clientType, data) => {
    setIsLoading(true)
    let sortTableUrl = '';
    if (action === 'changePage') {
      setTableState((prevState) => {
        if (clientType === 'submitted') {
          return {
            ...prevState,
            submitted: { ...prevState.submitted, pageCounter: data }
          }
        } else {
          return {
            ...prevState,
            unsubmitted: { ...prevState.unsubmitted, pageCounter: data }
          }
        }
      })
      sortTableUrl = `/api/v1/practice_reportable?client_type=${clientType}&page=${data}&rows=${'25'}&sort=${tableState[clientType].sort}&direction=${tableState[clientType].isDesc ? 'desc' : 'asc'}&naics_string=${selectedFilters.naics_string === 'All' ? '' : selectedFilters.naics_string}&revenue_band=${selectedFilters.revenue_band === 'All' ? '' : selectedFilters.revenue_band}&region=${selectedFilters.region === 'All' ? '' : selectedFilters.region}&partner=${selectedFilters.partner === 'All' ? '' : selectedFilters.partner}&office=${selectedFilters.office === 'All' ? '' : selectedFilters.office}&status=${selectedFilters.status === 'All' ? '' : selectedFilters.status}&year=${selectedFilters.year}&commit=filter`
    }

    if (action === 'sort') {
      setTableState((prevState) => {
        if (clientType === 'submitted') {
          return {
            ...prevState,
            submitted: {
              sort: data,
              isDesc: !prevState.submitted.isDesc,
              pageCounter: prevState.submitted.pageCounter
            }
          }
        } else {
          return {
            ...prevState,
            unsubmitted: {
              sort: data,
              isDesc: !prevState.unsubmitted.isDesc,
              pageCounter: prevState.unsubmitted.pageCounter
            }
          }
        }
      })
      sortTableUrl = `/api/v1/practice_reportable?client_type=${clientType}&page=${tableState[clientType].pageCounter}&rows=${'25'}&sort=${data}&direction=${!tableState[clientType].isDesc ? 'desc' : 'asc'}&naics_string=${selectedFilters.naics_string === 'All' ? '' : selectedFilters.naics_string}&revenue_band=${selectedFilters.revenue_band === 'All' ? '' : selectedFilters.revenue_band}&region=${selectedFilters.region === 'All' ? '' : selectedFilters.region}&partner=${selectedFilters.partner === 'All' ? '' : selectedFilters.partner}&office=${selectedFilters.office === 'All' ? '' : selectedFilters.office}&status=${selectedFilters.status === 'All' ? '' : selectedFilters.status}&year=${selectedFilters.year}&commit=filter`
    }

    const response = await fetch(sortTableUrl);
    const json = await response.json();
    setData(prevState => {
      if (clientType === 'submitted') {
        return {
          ...prevState,
          submitted_children: json.submitted_children,
        }
      } else {
        return {
          ...prevState,
          unsubmitted_children: json.unsubmitted_children,
        }
      }
    })
    setIsLoading(false)
  }

  const findSelectedIndustry = () => {
    let selectedCode = ''
    let selectedIndustry = ''

    if (data.drillup) {
      selectedCode = selectedFilters.naics_string
      data.filterOptions['naics_string'].forEach(element => {
        element[0] === selectedCode ? selectedIndustry = element[1] : null
      });
    } else {
      selectedCode = 'All'
    }
    selectedIndustry = selectedIndustry.split(' - ').join('')
    return [selectedCode, selectedIndustry]
  }

  const handleMouseEnter = (item) => {
    setActivePopover(item);
  };

  const handleMouseLeave = (item) => {
    if (item === 'leave') {
      setActivePopover(null);
    }
  };

  const openFiltersModal = () => {
    setFiltersModalIsOpen(true)
  }

  const closeFiltersModal = () => {
    setFiltersModalIsOpen(false)
  }

  const saveTabOrder = async (newTabs) => {
    let updates = []
    let newTabsOrder = newTabs.map((t, i) => {
      t.tab_order = i + 1
      updates.push({ id: t.id, tab_order: t.tab_order })
      return t
    })
    setReportsOnTabs(newTabsOrder);

    try {
      const res = await fetch("/api/v1/preferences/update_views", {
        method: "PATCH",
        headers: {
          'X-CSRF-Token': window.token,
          'Content-Type': 'application/json',
        },
        body: JSON.stringify({
          updates: updates
        }),
      });

      if (!res.ok) {
        throw new Error('Network response was not ok.');
      } else {
        setReportsOnTabs(newTabsOrder)
      }
    } catch (error) {
      console.error("Error saving tab order:", error);
    }
  }

  const updateTabActiveView = async (newTab, action = null) => {
    setActiveTab(newTab.key);
    let updates = [];

    const newTabs = reportsOnTabs.map((t) => {
      if (t.key === newTab.key) {
        t.active_view = true;
        updates.push(t);
      } else {
        if (t.active_view) {
          t.active_view = false;
          updates.push(t);
        }
      }
      return t;
    });

    setReportsOnTabs(action === 'addNote' ? [...newTabs, newTab] : newTabs);

    try {
      const res = await fetch("/api/v1/preferences/update_views", {
        method: "PATCH",
        headers: {
          'X-CSRF-Token': window.token,
          'Content-Type': 'application/json',
        },
        body: JSON.stringify({
          updates: updates
        }),
      });

      if (!res.ok) {
        throw new Error('Network response was not ok.');
      }
    } catch (error) {
      console.error("Error saving tab order:", error);
    }
  }

  const onDragEnd = (result) => {
    if (!result.destination) return;
    const newTabs = Array.from(reportsOnTabs);
    const [movedTab] = newTabs.splice(result.source.index, 1);
    newTabs.splice(result.destination.index, 0, movedTab);
    saveTabOrder(newTabs);
  };

  const handleNewNotesName = (e) => {
    let name = e.target.value;
    if (name.length === 0) {
      setNotesInput(prevState => {
        return {
          ...prevState, error: 'Please enter a name for the new tab.', name: name
        }
      })
    } else {
      setNotesInput(prevState => {
        return {
          ...prevState,
          error: null,
          name: name
        }
      })
    }
  }

  const handleNotePermissions = (permission) => {
    setNotesInput(prevState => {
      return {
        ...prevState,
        permissions: permission
      }
    })
  }

  const handlePDFandPrintChecked = (title) => {
    setDisplayPages((prevState) => {
      return prevState.map((page) => {
        if (page.title === title) {
          return { ...page, checked: !page.checked }
        }
        return page
      })
    })
  }

  useEffect(() => {
    setDisplayPages((prevState) => {
      const coreTitles = ['Client Analysis', 'Profit & Loss', 'Balance Sheet', 'Dashboard']
      const corePages = coreTitles.map((title) => {
        const existing = prevState.find((page) => page.title === title)
        return {
          title,
          checked: existing ? existing.checked : true,
        }
      })
      const notePages = noteTabs.map((tab) => {
        const existing = prevState.find((page) => page.title === tab.name)
        return {
          title: tab.name,
          checked: existing ? existing.checked : true,
        }
      })
      return [...corePages, ...notePages]
    })
  }, [noteTabs])

  const getDisplayClass = (title, tabKey = null) => {
    if (PDFPrintModalOpen) {
      return displayPages.find((page) => page.title === title)?.checked ? 'show-section' : 'hide-on-print'
    }
    return activeTab === tabKey ? 'show-section' : 'hide-section'
  }

  const createCompanyNotes = async (cleanHTML, tab = null) => {
    if (tab?.report === 'practice_notes' || activeTab?.report === 'practice_notes') {
      setIsLoading(true)
      const newActiveTab = tab ? tab : activeTab
      try {
        const res = await fetch(`/api/v1/company_notes`, {
          method: 'POST',
          headers: {
            'X-CSRF-Token': window.token,
            'Content-Type': 'application/json',
          },
          body: JSON.stringify({
            company_note: {
              notes: cleanHTML,
              preference_id: newActiveTab.id
            }
          }),
        })
  
        const resJson = await res.json()
  
        if (!res.ok) {
          throw new Error('Network response was not ok. Could not save note changes.');
        } else {
          const notes = resJson.message === 'exists' ? resJson.notes : cleanHTML
          const newNote = { notes: notes, id: resJson.id, preference_id: newActiveTab.id }
          setActiveCompanyNote(newNote)
          setCompanyNotes(prevState => {
            return [...prevState, newNote]
          })
          setIsLoading(false)
        }
      } catch (e) {
        console.log(e)
      }
    }
  }

  const updateCompanyNotes = async (cleanHTML, note) => {
    try {
      if (note.notes !== cleanHTML) {
        const res = await fetch(`/api/v1/company_notes/${note.id}`, {
          method: 'PATCH',
          headers: {
            'X-CSRF-Token': window.token,
            'Content-Type': 'application/json',
          },
          body: JSON.stringify({
            company_note: {
              notes: cleanHTML
            }
          }),
        })
        setActiveCompanyNote(prevState => {
          return { ...prevState, notes: cleanHTML }
        })
  
        setCompanyNotes(prevState => { 
          let newNotes = prevState.map(n => {
            return n.preference_id === note.preference_id ? { ...n, notes: cleanHTML } : n
          })
          return newNotes
        })
  
        if (!res.ok) {
          throw new Error('Network response was not ok. Could not save note changes.');
        }
      }
    } catch (e) {
      console.log(e)
    }
  }


  const createNewNotesTab = async (e) => {
    e.preventDefault();

    if (notesInput.name.length === 0) {
      setNotesInput(prevState => {
        return {
          ...prevState, error: 'Please enter a name for the new tab.'
        }
      })
    } else {
      let tabOrder = reportsOnTabs.length + 1
      try {
        const res = await fetch(`/api/v1/preferences/new_notes_tab`, {
          method: 'POST',
          headers: {
            'X-CSRF-Token': window.token,
            'Content-Type': 'application/json',
          },
          body: JSON.stringify({
            key: 'practice_notes',
            name: notesInput.name,
            report: 'practice_notes',
            permissions: notesInput.permissions,
            page: 'practice',
            tab_order: tabOrder
          }),
        })

        const resJson = await res.json();

        if (!res.ok) {
          throw new Error('Network response was not ok.');
        } else {
          const newNote = resJson.active_note
          newNote.can_edit = true
          setNoteTabs(prevState => {
            return [...prevState, newNote]
          })
          setOpenNotesForm(false)
          createCompanyNotes("", newNote)
          updateTabActiveView(newNote, 'addNote')
          toast.success('New Notes Tab Created!', {
            position: 'top-right',
            autoClose: 2000,
            hideProgressBar: true,
            closeOnClick: true,
            pauseOnHover: true,
            draggable: false,
            progress: undefined,
          });
        }
      } catch (error) {
        console.log(error)
        alert('Sorry something went wrong. Changes were not saved properly.');
      }
    }
  }

  const deleteReportTab = async (noteTab) => {
    const isActiveTab = noteTab.key === activeTab
    try {
      const res = await fetch(`/api/v1/preferences/${noteTab.id}`, {
        method: 'DELETE',
        headers: {
          'X-CSRF-Token': window.token,
          'Content-Type': 'application/json',
        }
      })

      if (!res.ok) {
        throw new Error('Network response was not ok.');
      } else {
        if (isActiveTab) {
          setActiveTab('client-analysis')
          const clientTab = reportsOnTabs.find(tab => tab.key === 'client-analysis')
          updateTabActiveView(clientTab)
        }
        setReportsOnTabs(prevState => {
          return  prevState.filter(tab => tab.id !== noteTab.id)
        })

        setNoteTabs(prevState => {
          return prevState.filter(tab => tab.id !== noteTab.id);
        });

        setCompanyNotes(prevState => {
          return prevState.filter(tab => tab.preference_id !== noteTab.id);
        });
      }
    } catch (error) {
      console.log(error)
      alert('Sorry something went wrong. Changes were not saved properly.');
    }
  }

  const countPlainTextCharacters = (html) => {
    const tempDiv = document.createElement('div');
    tempDiv.innerHTML = html;
    const plainText = tempDiv.textContent || tempDiv.innerText || '';
    return plainText.length;
  }

  const onChangeNotes = useCallback(
    (note, canEdit, html) => debounce((value) => {
      if (canEdit) {
        const cleanHTML = DOMPurify.sanitize(value, sanitizeOptions);
        let characterCount = countPlainTextCharacters(cleanHTML);
        if (characterCount <= 50000) {
          if (note?.id) {
            updateCompanyNotes(cleanHTML, note)
          } else {
            // Happens on page load?
            createCompanyNotes(cleanHTML)
          }
        }
      }
    }, 2000),
    []
  );

  const getReportComponent = (tab, notes, pdf = false) => {
    if (pdf) {
      return (
        <TextEditorPDF
          key={`${notes.id}-pdf`}
          companyNotes={notes}
        />
      )
    }
    return (
      <TextEditor
        key={`${notes.id}-${companyNotes.length}`}
        tabInfo={tab}
        companyNotes={notes}
        onChangeNotes={onChangeNotes}
        page={'practice'}
      />
    )
  }

  const renderNotes = () => {
    return (
      noteTabs.map((noteTab) => {
        const companyNote = companyNotes.find(n => n.preference_id === noteTab.id) || { notes: '' };
        const page = displayPages.find(p => p.title === noteTab.name);
        const cssClass = PDFPrintModalOpen
          ? (page?.checked ? 'show-section' : 'hide-on-print')
          : (activeTab === noteTab.key ? 'show-section' : 'hide-section')
        return (
          <div
            key={noteTab.key}
            className={cssClass}
          >
            {getReportComponent(noteTab, companyNote, PDFPrintModalOpen)}
          </div>
        );
      })
    )
  }

  const renderNotesTabs = () => {
    return (
      noteTabs.map((noteTab) => {
        return (
          <li key={noteTab.key} id={`${noteTab.key}-tab`} className={activeTab === noteTab.key ? 'tab-item active' : 'tab-item'} role='presentation' onClick={() => setActiveTab(noteTab.key)}>
             <span className="tab-name">{noteTab.name}</span>
                <button
                  type="button"
                  className="view-close-btn"
                  onClick={(e) => {
                    e.stopPropagation();
                    deleteReportTab(noteTab)
                  }}
                >
                  &times;
                </button>
          </li>
        );
      })
    )
  }

  if (data.year > 0) {
    let naicsInfo = findSelectedIndustry()
    let naicsDisplayFilterTop = naicsInfo[1] ? `NAICS: ${naicsInfo[0]}, ${naicsInfo[1]}` : `NAICS: ${naicsInfo[0]}`
    return (
      <div style={{ opacity: (isLoading ? 0.6 : 1) }}>
        {practiceCalcsProgressBar ?
          <ProgressBarModal
            job={'PracticeCalculationWorker'}
            refresh={true}
            path={'/group_reports/practice'}
          /> : null}
        <div id='sticky-topnav-left-btns'>
          <ExportPracticeFirmPDF
            {...props}
            name={'Practice'}
            data={data}
            naicsInfo={naicsInfo}
            activeTab={activeTab}
            noteTabs={noteTabs}
            reportsOnTabs={reportsOnTabs}
            companyNotes={companyNotes}
            dashboard={dashboard}
            PDFPrintModalOpen={PDFPrintModalOpen}
            selectedFilters={selectedFilters}
            setSelectedFilters={setSelectedFilters}
            handleSubmit={handleSubmit}
            onChangeNotes={onChangeNotes}
            handleFocusedClients={handleFocusedClients}
            tableState={tableState}
            handleTableChanges={handleTableChanges}
            setIsLoading={setIsLoading}
            setTableState={setTableState}
            dashboardViewModalState={dashboardViewModalState}
            getDashBoardView={getDashBoardView}
            handleDashboardViewModal={handleDashboardViewModal}
            handleOnLayoutChange={handleOnLayoutChange}
            handleToggleDraggable={handleToggleDraggable}
            page={'practice'}
            year={data.year}
            yearRange={[data.year]}
          />
          <ExportDropdown
            filters={selectedFilters}
            planAccess={{
              export_to_excel: true,
            }}
            page={'practice'}
            year={data.year}
            xlsx={true}
          />
        </div>
        <div id='sticky-topnav-right-btns'>
          <button className='hide-on-print' onClick={() => setIsOpen(true)}><FontAwesomeIcon icon={faQuestionCircle} /></button>
        </div>
        <div id='sticky-side-btns'>
          <span
            className='filters-btn-span hide-on-print'
            onMouseEnter={() => handleMouseEnter('filters')}
            onMouseLeave={() => handleMouseLeave('leave')}
          >
            <button className='filters-btn'><FontAwesomeIcon icon={faAnglesLeft} onClick={() => openFiltersModal()} /></button>
            {activePopover === 'filters' && (
              <div className='filters-popover'>
                Display Filters
              </div>)}
          </span>
        </div>
        <ToastContainer
          position='top-right'
          autoClose={5000}
          hideProgressBar
          newestOnTop={false}
          closeOnClick
          rtl={false}
          pauseOnFocusLoss
          draggable={false}
          pauseOnHover
          theme='colored'
        />
        <Modal
          className={{
            base: 'new-report-tab-content',
            afterOpen: 'new-report-tab-content_after-open',
            beforeClose: 'new-report-tab-content_before-close',
          }}
          overlayClassName={{
            base: 'new-report-tab-overlay-base',
            afterOpen: 'new-report-tab-overlay-base_after-open',
            beforeClose: 'new-report-tab-overlay-base_before-close',
          }}
          isOpen={openNotesForm}
          onRequestClose={() => setOpenNotesForm(false)}
          shouldCloseOnOverlayClick={false}
          closeTimeoutMS={0}
          contentLabel='Add New Tab Name Modal'
        >
          <div className='new-report-tab-container'>
            <h1 className='company-modal-header'>Add a New Notes Tab</h1>
            <form id='new-report-tab-form' onSubmit={(e) => createNewNotesTab(e)}>
              <p className='error-message'>{notesInput.error}</p>
              <div>
                <label>New Notes Name:</label>
                <input value={notesInput.name} onChange={(e) => handleNewNotesName(e)} />
              </div>
              <div className='text-editor-permissions'>
                  <span>Note Permissions:</span>
                  <div className='radio-qs'>
                    <div className='radio-q'>
                        <input
                            type='radio'
                            id='permit-edit-and-view'
                            name='dashboard-view-permissions'
                            value='private'
                            checked={notesInput.permissions === 'private'}
                            onChange={(e) => handleNotePermissions(e.target.value)}
                            required
                        />
                        <label htmlFor='permit-edit-and-view'>Private</label>
                    </div>
                    <div className='radio-q'>
                        <input
                            type='radio'
                            id='permit-view'
                            name='dashboard-view-permissions'
                            value='view_only'
                            checked={notesInput.permissions === 'view_only'}
                            onChange={(e) => handleNotePermissions(e.target.value)}
                        />
                        <label htmlFor='permit-view'>All Can View Only</label>
                    </div>
                    <div className='radio-q'>
                        <input
                            type='radio'
                            id='permit-view'
                            name='dashboard-view-permissions'
                            value='edit_and_view'
                            checked={notesInput.permissions === 'edit_and_view'}
                            onChange={(e) => handleNotePermissions(e.target.value)}
                        />
                        <label htmlFor='permit-view'>All Can View and Edit</label>
                    </div>
                  </div>
              </div>
              <button className='run-report-btn' type='submit'>Create New Notes</button>
            </form>
            <button className='run-report-btn' type='button' onClick={() => setOpenNotesForm(false)}>CANCEL</button>
          </div>
        </Modal>
        <Modal
          className={{
            base: 'client-modal-content',
            afterOpen: 'client-modal-content_after-open',
            beforeClose: 'client-modal-content_before-close',
          }}
          overlayClassName={{
            base: 'overlay-base',
            afterOpen: 'overlay-base_after-open',
            beforeClose: 'overlay-base_before-close',
          }}
          isOpen={filtersModalIsOpen}
          onRequestClose={closeFiltersModal}
          shouldCloseOnOverlayClick={true}
          closeTimeoutMS={0}
          contentLabel='Practice Report Filters Modal'
        >
          <div>
            <header className='company-modal-header'>
              <h1 className='client-company-name'>Report Filters</h1>
            </header>
            <div className='report-filters-container'>
              <div className='client-info-div'>
                <p>{naicsDisplayFilterTop}</p>
              </div>
              <PRDropdownFilter filterOptions={data.filterOptions} handleSubmit={handleSubmit} selectedFilters={selectedFilters} setSelectedFilters={setSelectedFilters} />
            </div>
          </div>
        </Modal>
        <DashboardViewModal
          dashboardViewModalState={dashboardViewModalState}
          report={'practice'}
          handleDashboardViewModal={handleDashboardViewModal}
          createDashBoardView={createDashBoardView}
          deleteDashBoardView={deleteDashBoardView}
          updateDashBoardView={updateDashBoardView}
        />
        <div className='money-report-component money-content'>
          <div style={{pointerEvents: isLoading ? 'none' : 'auto'}}>
            <DragDropContext onDragEnd={onDragEnd}>
              <Droppable droppableId="tabs" direction="horizontal">
                {(provided) => (
                  <ul
                    id="nav-tabs-practice-report"
                    className="report-tab-list"
                    role="tablist"
                    ref={provided.innerRef}
                    {...provided.droppableProps}
                  >
                    {reportsOnTabs.map((tab, index) => {
                      let styleName = tab.key.includes('practice_notes') ? 'tab-item' : 'report-tab-item'
                      let styleActiveName = tab.key.includes('practice_notes') ? 'active' : 'normal-active'

                      return (
                        <Draggable key={tab.key} draggableId={tab.key.toString()} index={index}>
                          {(provided) => (
                            <li
                              ref={provided.innerRef}
                              {...provided.draggableProps}
                              {...provided.dragHandleProps}
                              key={tab.key}
                              className={
                                activeTab === tab.key
                                  ? `${styleName} ${styleActiveName}`
                                  : `${styleName}`
                              }
                              role="presentation"
                              onClick={(e) => {
                                e.stopPropagation();
                                updateTabActiveView(tab);
                              }}
                            >
                              <span className="tab-name">{tab.name}</span>
                              {
                                tab.key.includes('practice_notes') && (<button
                                                                      type="button"
                                                                      className="view-close-btn"
                                                                      onClick={(e) => {
                                                                        e.stopPropagation();
                                                                        deleteReportTab(tab)
                                                                      }}
                                                                    >
                                                                      &times;
                                                                    </button>)
                              }
                            </li>
                          )}
                        </Draggable>
                      );
                    })}
                    {provided.placeholder}
                    <div className="relative">
                      <button className="add-view-btn hide-on-print" onClick={() => setOpenNotesForm(true)}>
                        + Add Notes
                      </button>
                    </div>
                    <li key='edit-dashboard-li-item' id='edit-dashboard-tabs' className='edit-dashboard-section'>
                      {dashboard.noChangesMade ? null : <button key='save-dashboard-changes-btn' className='save-dashboard-btn' onClick={() => updateDashBoardView()}>Save Changes</button>}
                      {activeTab === 'dashboard' ? <button className='save-dashboard-btn' onClick={() => handleDashboardViewModal('add_view')}>+ New View</button> : null}
                      {activeTab === 'dashboard' ? <button className='save-dashboard-btn' onClick={() => handleDashboardViewModal('all_views')}>Edit My Views</button> : null}
                      <EditDashboard
                        key={'edit-dashboard-popup'}
                        page={'practice'}
                        dashboardLayoutType={''}
                        gridItemsSelected={dashboard.selectedItems}
                        noChangesMade={dashboard.noChangesMade}
                        handleDashboardSelections={handleDashboardSelections}
                        handleSelectAll={handleSelectAll}
                        updateDashBoardView={updateDashBoardView}
                      />
                    </li>
                  </ul>
                )}
              </Droppable>
            </DragDropContext>
          </div>
          {data.insufficientData
            ? <h1>{data.insufficientData}</h1>
            : <PracticeReport 
              {...props}
              data={data}
              naicsInfo={naicsInfo}
              reportsOnTabs={reportsOnTabs}
              activeTab={activeTab}
              noteTabs={noteTabs}
              companyNotes={companyNotes}
              dashboard={dashboard}
              PDFPrintModalOpen={PDFPrintModalOpen}
              selectedFilters={selectedFilters}
              setSelectedFilters={setSelectedFilters}
              handleSubmit={handleSubmit}
              onChangeNotes={onChangeNotes}
              handleFocusedClients={handleFocusedClients}
              tableState={tableState}
              handleTableChanges={handleTableChanges}
              setIsLoading={setIsLoading}
              setTableState={setTableState}
              dashboardViewModalState={dashboardViewModalState}
              getDashBoardView={getDashBoardView}
              handleDashboardViewModal={handleDashboardViewModal}
              handleOnLayoutChange={handleOnLayoutChange}
              handleToggleDraggable={handleToggleDraggable}
            />
          }
        </div>
        {props.super_user
          ? (<form id='mapping-form' className='hide-on-print' action='/practice_calculations' acceptCharset='UTF-8' data-remote='true' method='post' >
            <input type='hidden' name='authenticity_token' value={window.token} />
            <input name='utf8' type='hidden' value='✓' />
            <input
              type='submit'
              value='Update Practice Calculations'
              className='submit-mapping-button btn btn-primary success pull-right'
              onClick={() => {
                document.querySelector('.money-report-component').style.zIndex = 0;
                setPracticeCalcsProgressBar(true);
              }}
            />
          </form>)
          : null
        }
        {!copilotOpen && navbar.user_type === 'Admin' && (
          <button
            className="copilot-floating-btn"
            onClick={() => setCopilotOpen(true)}
            title="Ask Peerview"
          >
            <i className="fa fa-comments" />
          </button>
        )}
        <CopilotSlideOut
          isOpen={copilotOpen}
          onClose={() => setCopilotOpen(false)}
          activeTab={null}
          companyName={navbar.parent_company_name}
          userType={navbar.user_type}
          setupProd={navbar.setup}
          page={'practice'}
          filters={selectedFilters}
        />
      </div>
    )
  } else {
    return (
      <div style={{ 'height': '80vh', 'paddingTop': '30vh' }}>
        <LoaderGraphic />
      </div>
    )
  }
}

export default PracticeReportContainer;